import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "my-2"
};
const _hoisted_2 = {
  class: "grow"
};
const _hoisted_3 = {
  class: "flex items-center mb-2"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "flex items-center"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "flex flex-col items-end"
};
import { onBeforeRouteLeave } from "vue-router";
import { TransferLog } from "@/modules/transfer-market/entity";
import Team from "@/modules/team/components/Team.vue";
import PlayerLayout from "@/modules/team/pages/players/PlayerLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Transfers',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const logs = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const playerId = route.params.id;
      logs.value = await TransferLog.createQueryBuilder('log').innerJoinAndSelect('log.player', 'player').innerJoinAndSelect('log.season', 'season').leftJoinAndSelect('log.from', 'from').leftJoinAndSelect('from.country', 'fromCountry').leftJoinAndSelect('log.to', 'to').leftJoinAndSelect('to.country', 'toCountry').where('player.id = :playerId', {
        playerId
      }).orderBy('season.id', 'DESC').getMany();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createBlock(PlayerLayout, {
        onUpdated: _unref(refresh)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [logs.value.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_transfers_yet')
        }, null, 8, ["description"])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(logs.value, log => {
          return _openBlock(), _createElementBlock("div", {
            key: log.id,
            class: "flex items-center rounded bg-slate-50 mb-2 last:mb-0 p-3 px-4"
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.ArrowLeft,
            size: "1rem",
            class: "mr-2 text-red-600"
          }, null, 8, ["icon"]), log.from ? (_openBlock(), _createBlock(Team, {
            key: 0,
            team: log.from
          }, null, 8, ["team"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('without_club')), 1))]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.ArrowRight,
            size: "1rem",
            class: "mr-2 text-green-600"
          }, null, 8, ["icon"]), log.to ? (_openBlock(), _createBlock(Team, {
            key: 0,
            team: log.to
          }, null, 8, ["team"])) : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('without_club')), 1))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(_ctx.$date(log.season.startDate, 'YYYY')) + " / " + _toDisplayString(_ctx.$date(log.season.endDate, 'YYYY')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$money(log.price)), 1)])]);
        }), 128))])]),
        _: 1
      }, 8, ["onUpdated"]);
    };
  }
});